import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X } from 'lucide-react';

const ImageGallery = ({ images, showAllPics, setShowAllPics }) => {
  const [fullscreenIndex, setFullscreenIndex] = useState(null);

  useEffect(() => {
    if (showAllPics) {
      setFullscreenIndex(0);
    }
  }, [showAllPics]);

  const openFullscreen = (index) => {
    setFullscreenIndex(index);
    setShowAllPics(true);
  };

  const closeFullscreen = () => {
    setFullscreenIndex(null);
    setShowAllPics(false);
  };

  const nextImage = () => {
    setFullscreenIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setFullscreenIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  return (
    <div className="relative mb-4">
      <div className="grid grid-cols-3 gap-2 aspect-[3/2] rounded-lg overflow-hidden">
        {images.slice(0, 6).map((image, index) => (
          <div 
            key={index} 
            className={`overflow-hidden ${
              index === 0 ? 'col-span-2 row-span-2' : ''
            }`}
          >
            <img
              src={image.src}
              alt={image.caption}
              className="w-full h-full object-cover cursor-pointer"
              onClick={() => openFullscreen(index)}
            />
          </div>
        ))}
      </div>

      {fullscreenIndex !== null && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center">
          <button
            onClick={closeFullscreen}
            className="absolute top-4 right-4 text-white"
          >
            <X size={24} />
          </button>
          <button
            onClick={prevImage}
            className="absolute left-4 text-white"
          >
            <ChevronLeft size={36} />
          </button>
          <div className="text-center max-w-4xl w-full">
            <img
              src={images[fullscreenIndex].src}
              alt={images[fullscreenIndex].caption}
              className="max-w-full max-h-[80vh] object-contain mx-auto"
            />
            <p className="text-white mt-4 text-lg">{images[fullscreenIndex].caption}</p>
          </div>
          <button
            onClick={nextImage}
            className="absolute right-4 text-white"
          >
            <ChevronRight size={36} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageGallery;